export default __webpack_public_path__ + "static/media/front_intro.406e083f.png";